import client from "./client";

const DividendService = {};

DividendService.create = function (data) {
  return client.post(`/dividend`, data);
};

export default DividendService;
